var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showNavigation)?_c('navigation-bar'):_vm._e(),_c('two-factor-auth-modal'),_c('div',{staticClass:"mainDiv"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }